export const scheduled_batches_page_query = {
  filter: '',
  max_rows: 100,
  created_by: null,
  parameter_name: '',
  parameter_value: '',
  include_archived: false,
};

export const scheduled_batches_query = {
  filter: '',
  max_rows: 100,
  created_by: null,
  parameter_name: '',
  parameter_value: '',
  include_archived: false,
};
